<template>
    <div class="text-center flex flex-col items-center justify-center"
        :class="{ 'bg-[color:var(--background)]': dark }">
        <div class="m-5 font-medium">
            <h2>{{ title }}</h2>
        </div>
        <div class="m-3 subtitle w-full">
            <p>{{ subtitle }}</p>
        </div>
        <div
            class="flex flex-col my-4 gap-4 sm:gap-0 sm:flex-row sm:flex-wrap h-min place-content-center place-items-start items-stretch max-w-7xl w-full md:w-fit xl:w-max overflow-visible relative">
            <UseCaseSection v-for="usecase of limitedUsecases" :title="usecase.title" :body="usecase.body"
                :icon="usecase.icon" :image_url="usecase.image_url" :button="usecase.button"
                :total="String(usecases?.length)" :image_40="usecase.image_40"
                :category="hideCategories ? undefined : usecase.category" :hide_button="hide_button"
                class="rounded-lg sm:px-6 sm:py-8 xl:mt-0" :three_col="three_col" />
        </div>
        <a v-if="button_text" :href="button_link"
            class="btn btn-primary mt-8 w-full md:w-auto text-center sm:text-left">{{ button_text }}</a>
    </div>
</template>

<script lang="ts">
import type { PropType } from 'vue';
import type { IHeroButton } from './Hero.vue';

export default {
    props: {
        title: String,
        button_text: String,
        button_link: String,
        usecases: {
            type: Array as PropType<{ title?: string; body: string; icon?: string; image_url?: string; image_40?: boolean; button?: IHeroButton; category?: string; }[]>,
            default: () => []
        },
        maxItems: {
            type: Number,
            default: undefined
        },
        small: Boolean,
        dark: Boolean,
        white: Boolean,
        button: Object as PropType<IHeroButton>,
        subtitle: String,
        hide_button: Boolean,
        hideCategories: {
            type: Boolean,
            default: false
        },
        three_col: Boolean,
    },
    computed: {
        limitedUsecases() {
            if (!this.maxItems) return this.usecases;
            return this.usecases.slice(0, this.maxItems);
        }
    }
};
</script>
